import { MouseEvent } from 'react'
import { Highlight } from '../at-tabs/shared/highlight'
import { textColorTransition } from '../at-tabs/shared/classes'
import { AtLinkTarget } from '../at-link'

export interface Link {
  href: string
  label: string
  selected?: boolean
  disabled?: boolean
  target?: AtLinkTarget
  onTrackClick?: (event?: MouseEvent<HTMLAnchorElement>) => void
}

export interface AtNavbarLinkProps extends Link {
  className?: string
  open?: boolean
}

export const AtNavbarLink = ({
  disabled,
  href,
  label,
  open,
  selected,
  target,
  onTrackClick,
  className,
}: AtNavbarLinkProps) => (
  <div
    className={`${className} group relative h-full leading-1.5 inline-flex justify-center items-center gap-2 py-2 ${
      !disabled ? 'hover:text-neutrals-700 focus-within:text-neutrals-700' : ''
    } ${disabled ? 'text-neutrals-500' : selected ? 'text-primary-500' : 'text-neutrals-800'} ${textColorTransition}`}
  >
    <div className="focus-visible-within peer flex gap-2 items-center">
      <a
        onClick={(event) => {
          if (onTrackClick) onTrackClick(event)
        }}
        href={!disabled ? href : undefined}
        target={target}
        aria-disabled={disabled}
        className="focus:outline-none"
      >
        {label}
      </a>
    </div>
    <Highlight
      selected={selected}
      disabled={disabled}
      className="absolute -bottom-[1px] peer-[:has(:focus-visible)]:w-full peer-[:has(:focus-visible)]:bg-current"
    />
  </div>
)
